import { LinearProgress, Box, Typography } from '@mui/material';

interface ProgressBarProps {
  backgroundColor?: '#FFFFFF4d' | '#F4F4F4';
  colorText?: '#FFFFFF' | '#ACACAC';
  progressNumber?: number;
}

export default function ProgressBar({
  backgroundColor = '#FFFFFF4d',
  colorText = '#FFFFFF',
  progressNumber = 20,
}: ProgressBarProps) {
  return (
    <Box
      data-testid="progress-rate-bar"
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        gap: '18px',
        padding: '6px 12px 8px',
        my: 2,
        backgroundColor,
        borderRadius: '16px',
        width: '100%',
        margin: 0,
      }}
    >
      <Box sx={{ width: '100%' }}>
        <Box sx={{ mb: '4px' }}>
          <Typography color={colorText} variant="caption">
            Progresso do cadastro
          </Typography>
        </Box>
        <Box>
          <LinearProgress
            sx={{
              '& .MuiLinearProgress-bar': {
                backgroundColor: '#019E07',
              },
              height: '6px',
              borderRadius: '16px',
              backgroundColor: '#E7E7E7',
            }}
            variant="determinate"
            value={progressNumber}
          />
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          minWidth: 35,
        }}
      >
        <Typography
          variant="body2"
          color={colorText}
        >{`${progressNumber}%`}</Typography>
      </Box>
    </Box>
  );
}
